var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeeLookup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.988,
    height: 58.888,
    viewBox: "0 0 47.988 58.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9527",
    "data-name": "Group 9527",
    transform: "translate(-270 -456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "employees",
    transform: "translate(270 456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11182",
    "data-name": "Path 11182",
    d: "M235.5,272.267l-4.18-1.645H216.485l-4.18,1.645a4.047,4.047,0,0,0-2.562,3.928l.508,12.671a1.349,1.349,0,0,0,1.348,1.3h24.613a1.349,1.349,0,0,0,1.348-1.3l.508-12.671A4.047,4.047,0,0,0,235.5,272.267Z",
    transform: "translate(-190.081 -248.342)",
    fill: "#dbd9dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11183",
    "data-name": "Path 11183",
    d: "M342.018,320.77l-.863,14.839h3.7l-.863-14.839Z",
    transform: "translate(-309.18 -293.79)",
    fill: "#5d5360"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11184",
    "data-name": "Path 11184",
    d: "M348.4,301.879h-1.149a.774.774,0,0,1-.774-.774v-1.924h2.7V301.1A.775.775,0,0,1,348.4,301.879Z",
    transform: "translate(-314.004 -274.224)",
    fill: "#4b3f4e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18303",
    "data-name": "Rectangle 18303",
    width: 9.443,
    height: 8.094,
    transform: "translate(29.102 16.862)",
    fill: "#b48764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11185",
    "data-name": "Path 11185",
    d: "M310.5,215.345a8.057,8.057,0,0,0,9.443,0v-2.519H310.5Z",
    transform: "translate(-281.394 -195.963)",
    fill: "#966d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11186",
    "data-name": "Path 11186",
    d: "M282.607,32.94a8.725,8.725,0,0,0-5.283,2.023s-2.81,0-2.81,3.372a25.2,25.2,0,0,0,.674,5.375H290.7C292.05,36.291,288.846,32.6,282.607,32.94Z",
    transform: "translate(-248.784 -32.918)",
    fill: "#5c414b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11187",
    "data-name": "Path 11187",
    d: "M278.561,60.7a6.059,6.059,0,0,1-1.237-5.964s-2.81,0-2.81,3.372a25.2,25.2,0,0,0,.674,5.375h3.372V60.7Z",
    transform: "translate(-248.785 -52.688)",
    fill: "#503441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11188",
    "data-name": "Path 11188",
    d: "M283.506,114.211h-.674l-.889-1.622a.678.678,0,0,0-.72-.335,14.083,14.083,0,0,1-8.468-.737.663.663,0,0,0-.821.214,14.242,14.242,0,0,1-1.887,2.121,1.351,1.351,0,0,1-.917.359h-.486a1.318,1.318,0,0,0-.226.024,1.426,1.426,0,0,0-1.1,1.423v.489a1.417,1.417,0,0,0,1.041,1.4,1.335,1.335,0,0,0,.411.032.657.657,0,0,1,.689.548,6.737,6.737,0,0,0,13.255,0,.655.655,0,0,1,.653-.544h.139a1.349,1.349,0,0,0,1.349-1.349v-.674A1.349,1.349,0,0,0,283.506,114.211Z",
    transform: "translate(-242.263 -104.093)",
    fill: "#c39772"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11189",
    "data-name": "Path 11189",
    d: "M272.039,118.587v-5.281a.638.638,0,0,0-.105.1,14.243,14.243,0,0,1-1.887,2.121,1.351,1.351,0,0,1-.917.359h-.486a1.319,1.319,0,0,0-.226.024,1.426,1.426,0,0,0-1.1,1.423v.489a1.417,1.417,0,0,0,1.041,1.4,1.334,1.334,0,0,0,.411.032.657.657,0,0,1,.689.548,6.72,6.72,0,0,0,7.965,5.389A6.747,6.747,0,0,1,272.039,118.587Z",
    transform: "translate(-242.263 -105.771)",
    fill: "#b48764"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9504",
    "data-name": "Group 9504",
    transform: "translate(26.404 20.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11190",
    "data-name": "Path 11190",
    d: "M289.13,256.159l-4.921-4.306a.674.674,0,0,0-.921.031l-1.577,1.577,3.134,4.7a1.349,1.349,0,0,0,2.076.206Z",
    transform: "translate(-281.711 -251.686)",
    fill: "#edebed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11191",
    "data-name": "Path 11191",
    d: "M360.869,256.159l4.921-4.306a.674.674,0,0,1,.921.031l1.577,1.577-3.134,4.7a1.349,1.349,0,0,1-2.076.206Z",
    transform: "translate(-353.45 -251.686)",
    fill: "#edebed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11192",
    "data-name": "Path 11192",
    d: "M462.8,308.76l2.934-2.934a4.034,4.034,0,0,1,.6,2.273l-.508,12.671a1.349,1.349,0,0,1-1.348,1.3h-2.864V311.622A4.047,4.047,0,0,1,462.8,308.76Z",
    transform: "translate(-444.756 -300.752)",
    fill: "#edebed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11193",
    "data-name": "Path 11193",
    d: "M282.485,365.971h3.173a.774.774,0,0,0,.774-.774v-.475a.774.774,0,0,0-.774-.774h-3.173a.774.774,0,0,0-.774.774v.475A.774.774,0,0,0,282.485,365.971Z",
    transform: "translate(-281.711 -353.426)",
    fill: "#edebed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11194",
    "data-name": "Path 11194",
    d: "M21.855,315.161l-3.639-1.589H6.068l-3.639,1.589A4.047,4.047,0,0,0,0,319.042l.371,8.753a1.349,1.349,0,0,0,1.348,1.292H22.56a1.349,1.349,0,0,0,1.348-1.292l.371-8.753A4.047,4.047,0,0,0,21.855,315.161Z",
    transform: "translate(-0.001 -287.267)",
    fill: "#5d5360"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18304",
    "data-name": "Rectangle 18304",
    width: 6.745,
    height: 6.745,
    transform: "translate(8.768 21.584)",
    fill: "#fad7a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11195",
    "data-name": "Path 11195",
    d: "M93.551,265.158a8.067,8.067,0,0,0,6.745,0V263.2H93.551Z",
    transform: "translate(-84.783 -241.615)",
    fill: "#f0c891"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 4.047,
    cy: 4.047,
    rx: 4.047,
    ry: 4.047,
    transform: "translate(8.093 0)",
    fill: "#deaf73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 8.094,
    cy: 7.757,
    rx: 8.094,
    ry: 7.757,
    transform: "translate(4.046 3.372)",
    fill: "#d59f63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11196",
    "data-name": "Path 11196",
    d: "M48.574,99.76c-2.7-2.7-3.1-5.024-3.038-6.484a7.572,7.572,0,0,0-2.358,5.472,7.457,7.457,0,0,0,1.16,3.995Z",
    transform: "translate(-39.131 -87.618)",
    fill: "#cd915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11197",
    "data-name": "Path 11197",
    d: "M52.44,145.315a3.654,3.654,0,0,0-.387-.028,1.349,1.349,0,0,1-.954-.4l-.582-.582a1.338,1.338,0,0,0-.872-.393A22.183,22.183,0,0,1,41.8,142.1a.673.673,0,0,0-.871.221,13.8,13.8,0,0,1-2.221,2.611,1.347,1.347,0,0,1-.914.357h-.486a1.331,1.331,0,0,0-.226.024,1.426,1.426,0,0,0-1.1,1.423v.489a1.417,1.417,0,0,0,1.041,1.4,1.337,1.337,0,0,0,.411.032.657.657,0,0,1,.689.548,6.737,6.737,0,0,0,13.255,0,.657.657,0,0,1,.689-.548,1.336,1.336,0,0,0,.411-.032,1.417,1.417,0,0,0,1.041-1.4v-.615A1.408,1.408,0,0,0,52.44,145.315Z",
    transform: "translate(-32.609 -131.797)",
    fill: "#ffe1b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11198",
    "data-name": "Path 11198",
    d: "M40.7,154.079v-5.331a14.171,14.171,0,0,1-2,2.277,1.347,1.347,0,0,1-.914.357h-.486a1.317,1.317,0,0,0-.226.024,1.426,1.426,0,0,0-1.1,1.423v.489a1.417,1.417,0,0,0,1.041,1.4,1.336,1.336,0,0,0,.411.032.657.657,0,0,1,.689.548,6.72,6.72,0,0,0,7.965,5.389A6.747,6.747,0,0,1,40.7,154.079Z",
    transform: "translate(-32.609 -137.891)",
    fill: "#fad7a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9505",
    "data-name": "Group 9505",
    transform: "translate(0 24.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11199",
    "data-name": "Path 11199",
    d: "M3.627,342.93l-2.464-2.957A4.036,4.036,0,0,0,0,342.967l.371,8.753a1.349,1.349,0,0,0,1.348,1.292h3v-7.059A4.721,4.721,0,0,0,3.627,342.93Z",
    transform: "translate(0 -335.755)",
    fill: "#6f6571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11200",
    "data-name": "Path 11200",
    d: "M209.787,342.929l2.464-2.957a4.036,4.036,0,0,1,1.159,2.994l-.371,8.753a1.349,1.349,0,0,1-1.348,1.292h-3v-7.059A4.722,4.722,0,0,1,209.787,342.929Z",
    transform: "translate(-189.133 -335.754)",
    fill: "#6f6571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11201",
    "data-name": "Path 11201",
    d: "M75.361,295.163a.674.674,0,0,0-.954,0l-3.261,3.261a.438.438,0,0,1-.619,0l-3.261-3.261a.674.674,0,0,0-.954,0l-1.547,1.547,2.5,4.051a.674.674,0,0,0,1.012.159l1.5-1.276a.238.238,0,0,1,.392.181v12.4h1.349v-12.4a.238.238,0,0,1,.392-.181l1.5,1.276a.674.674,0,0,0,1.012-.159l2.5-4.051Z",
    transform: "translate(-58.697 -294.966)",
    fill: "#6f6571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11202",
    "data-name": "Path 11202",
    d: "M65.541,401.952h2.5a.774.774,0,0,0,.774-.774V400.7a.774.774,0,0,0-.774-.774h-2.5a.774.774,0,0,0-.774.774v.475A.774.774,0,0,0,65.541,401.952Z",
    transform: "translate(-58.697 -390.091)",
    fill: "#6f6571"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "meal",
    transform: "translate(278.511 484.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11219",
    "data-name": "Path 11219",
    d: "M24.767,0A15.327,15.327,0,0,0,14.525,3.906C12.1,6.626,10,10.833,10,14.767A15.386,15.386,0,0,0,25.386,30.153c3.934,0,8.141-2.1,10.861-4.525A15.385,15.385,0,0,0,24.767,0Z",
    transform: "translate(-9.381 0)",
    fill: "#e2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11220",
    "data-name": "Path 11220",
    d: "M122.842,52.367a3.344,3.344,0,0,0-3.344-3.344,3.344,3.344,0,0,0-4.473-1.535,3.344,3.344,0,0,0-4.693.587,3.332,3.332,0,0,0-2.425.419,3.771,3.771,0,0,0-1.156,2.6c-1.592.357-2.9,1.867-2.354,4.677,1.349,2.553,5.421,7.575,10.421,8.118,5.836.634,9.385-6.693,9.385-6.693A3.451,3.451,0,0,0,122.842,52.367Z",
    transform: "translate(-97.816 -43.887)",
    fill: "#fff0af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11221",
    "data-name": "Path 11221",
    d: "M98.941,80.961a2.752,2.752,0,0,1,1.771-3.871c0-.731.144-2.192.854-2.694a3.334,3.334,0,0,0-1.533,2.17,3.344,3.344,0,0,0-2.418,4.064,5.141,5.141,0,0,0,.44,1.041C98.716,81.684,99.143,81.41,98.941,80.961Z",
    transform: "translate(-91.474 -69.79)",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11222",
    "data-name": "Path 11222",
    d: "M1.238,73.321A15.328,15.328,0,0,1,5.144,63.079,15.385,15.385,0,1,0,26.867,84.8,15.385,15.385,0,0,1,1.238,73.321Z",
    transform: "translate(0 -59.173)",
    fill: "#c1e4fa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 0.929,
    cy: 0.929,
    rx: 0.929,
    ry: 0.929,
    transform: "translate(12.994 9.805)",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 0.929,
    cy: 0.929,
    rx: 0.929,
    ry: 0.929,
    transform: "translate(21.137 10.243)",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11223",
    "data-name": "Path 11223",
    d: "M168.044,250.986c-1.4.625-2.489,1.53-2.489,2.665,0,2.85,6.662,5.5,6.577,6.474a1.856,1.856,0,0,0,1.34,2.1,1.763,1.763,0,0,0,2.1-1.34,1.763,1.763,0,0,0,2.493-2.493,1.754,1.754,0,0,0,.941-.555l-2.552-4.29Z",
    transform: "translate(-155.304 -235.446)",
    fill: "#98ca91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11224",
    "data-name": "Path 11224",
    d: "M217.122,241.424c-.21-.951-4.177-5.179-5.58-6.037-.844-.517-3.669-.213-5.784.731a2.172,2.172,0,0,0,.779,1.311,6.119,6.119,0,0,1,2.154,3.25A1.743,1.743,0,0,0,212,240.7c.063-.262-.161-.533-.068-.765a1.7,1.7,0,0,0,.339.121,6.119,6.119,0,0,1,3.25,2.154,2.209,2.209,0,0,0,1.2.758A1.761,1.761,0,0,0,217.122,241.424Z",
    transform: "translate(-193.018 -220.578)",
    fill: "#68b181"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 0.929,
    cy: 0.929,
    rx: 0.929,
    ry: 0.929,
    transform: "translate(17.905 20.619)",
    fill: "#68b181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11225",
    "data-name": "Path 11225",
    d: "M314.053,209.6a1.763,1.763,0,0,0,0-3.526,1.763,1.763,0,0,0-.539-2.434,1.856,1.856,0,0,0-2.434.539,6.119,6.119,0,0,1-3.25,2.154,1.543,1.543,0,0,0,0,3.008,6.119,6.119,0,0,1,3.25,2.154,1.856,1.856,0,0,0,2.434.539A1.763,1.763,0,0,0,314.053,209.6Z",
    transform: "translate(-287.645 -190.793)",
    fill: "#98ca91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11226",
    "data-name": "Path 11226",
    d: "M142.708,310.238a1.763,1.763,0,0,1-3.526,0,1.763,1.763,0,0,1-2.434-.539,1.856,1.856,0,0,1,.539-2.434,6.118,6.118,0,0,0,2.154-3.25,1.543,1.543,0,0,1,3.008,0,6.119,6.119,0,0,0,2.154,3.25,1.856,1.856,0,0,1,.539,2.434A1.763,1.763,0,0,1,142.708,310.238Z",
    transform: "translate(-128.039 -284.066)",
    fill: "#c2e4a1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 0.929,
    cy: 0.929,
    rx: 0.929,
    ry: 0.929,
    transform: "translate(11.087 22.02)",
    fill: "#98ca91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11227",
    "data-name": "Path 11227",
    d: "M72.616,175.042c.01-2.8-2.533-5.09-5.68-5.1a6.114,6.114,0,0,0-3.6,1.125,3.8,3.8,0,0,0-1.19,3c-.01,2.8,2.113,4.878,2.531,6.465s1.4,2.964,3.133,2.971a4.4,4.4,0,0,0,1.655-.634,5.562,5.562,0,0,0,.572-1.385C70.467,179.9,72.606,177.846,72.616,175.042Z",
    transform: "translate(-58.299 -159.418)",
    fill: "#c38778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11228",
    "data-name": "Path 11228",
    d: "M226.67,182.433a1.763,1.763,0,0,0-3.526,0,1.763,1.763,0,0,0-2.434.539,1.856,1.856,0,0,0,.539,2.434,6.118,6.118,0,0,1,2.154,3.25,1.543,1.543,0,0,0,3.008,0,6.119,6.119,0,0,1,2.154-3.25,1.856,1.856,0,0,0,.539-2.434,1.763,1.763,0,0,0-2.434-.539Z",
    transform: "translate(-206.802 -169.484)",
    fill: "#c2e4a1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 0.929,
    cy: 0.929,
    rx: 0.929,
    ry: 0.929,
    transform: "translate(18.459 16.022)",
    fill: "#98ca91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11229",
    "data-name": "Path 11229",
    d: "M50.915,197.277c-.418-1.586-2.541-3.66-2.531-6.465a4.661,4.661,0,0,1,.88-2.7,4.883,4.883,0,0,0-2.119,3.934c-.01,2.8,2.113,4.878,2.531,6.465s1.4,2.964,3.133,2.971a2.911,2.911,0,0,0,2.583-1.563,2.778,2.778,0,0,1-1.345.324c-1.736-.006-2.715-1.384-3.133-2.971Z",
    transform: "translate(-44.226 -176.469)",
    fill: "#b1705b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11230",
    "data-name": "Path 11230",
    d: "M114.123,325.16h-2.911a.464.464,0,1,1,0-.929h2.911a.464.464,0,1,1,0,.929Z",
    transform: "translate(-103.89 -304.156)",
    fill: "#b1705b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11231",
    "data-name": "Path 11231",
    d: "M87.291,270.756H80.938a.464.464,0,1,1,0-.929h6.353a.464.464,0,1,1,0,.929Z",
    transform: "translate(-75.491 -253.12)",
    fill: "#b1705b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11232",
    "data-name": "Path 11232",
    d: "M93.577,218.908H88.19a.464.464,0,1,1,0-.929h5.387a.464.464,0,1,1,0,.929Z",
    transform: "translate(-82.294 -204.482)",
    fill: "#b1705b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9526",
    "data-name": "Group 9526",
    transform: "translate(11.707 9.186)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 0.929,
    cy: 0.929,
    rx: 0.929,
    ry: 0.929,
    transform: "translate(1.906)",
    fill: "#ffc250"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 0.929,
    cy: 0.929,
    rx: 0.929,
    ry: 0.929,
    transform: "translate(10.05 0.438)",
    fill: "#ffc250"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 0.929,
    cy: 0.929,
    rx: 0.929,
    ry: 0.929,
    transform: "translate(7.371 6.217)",
    fill: "#ffc250"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 0.929,
    cy: 0.929,
    rx: 0.929,
    ry: 0.929,
    transform: "translate(0 12.215)",
    fill: "#ffc250"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 0.929,
    cy: 0.929,
    rx: 0.929,
    ry: 0.929,
    transform: "translate(6.817 10.814)",
    fill: "#ffc250"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeLookup);
export default __webpack_public_path__ + "static/media/employee-lookup.404c9d3a6c2a66ac088ab645d3119fa1.svg";
export { ForwardRef as ReactComponent };